// The real book PDF lives in /public and downloads directly.
export const BOOK_DOWNLOAD_URL = "/coa-book.pdf";

export const PRICE = "$19.99";
export const WEBINAR_LINE = "Weekly Live Webinar Every Tuesday at 7 PM Central Time";
